<template>
    <div class="qc-tree" @contextmenu.stop="handleContextMenu($event)">
      <template>
        <template>
            <qc-tree-node
              v-for="(item, index) in root.childNodes"
              :node="item"
              :key="item.id"
              :node-index="index"
              :node-length="data.length"
              :render-content="renderContent"
              :lazy="lazy"
              :has-more="hasMore"
              :show-checkbox="showCheckbox"
            ></qc-tree-node>
          </template>
          <slot name="empty-tips"></slot>
      </template>
    </div>
</template>

<script>
import QcTreeNode from './treeNode.vue';
import Store from './Store';

export default {
  name: 'qc-tree',
  components: { QcTreeNode },
  props: {
    data: Array,
    node: Object,
    renderContent: Function,
    showCheckbox: {
      type: Boolean,
      default: false,
    },

    // 设置唯一主键
    nodeKey: String,

    lazy: {
      type: Boolean,
      default: false,
    },
    load: Function,
    loadMore: Function,
    hasMore: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hasAuthority: {
      type: Boolean,
      default: true,
    },
    expandAll: {
      type: Boolean,
      default: false,
    },
    // 鼠标左键多选
    multiSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isTree: true,
      level: 0,
      store: null,
      root: null,
      isInit: true,
      // 左键选中node
      activeNodeKey: '',
      currNode: null,
      // 右键选中node
      contextingNode: null,
      contextingNodeKey: '',
    };
  },
  watch: {
    data(val, old) {
      if (this.lazy && this.isInit && val.length > 0 && old.length === 0) {
        this.init();
        this.isInit = false;
      } else {
        this.store.setData(val);
      }
    },
    lazy(val) {
      this.store.lazy = val;
    },
  },
  methods: {

    getCurrentNode() {
      return this.store.currentNode;
    },

    getCheckedNodes() {
      return this.store.getCheckedNodes();
    },

    handleContextMenu(event) {
      this.$emit('contextmenu', event, null, null);
    },

    checkChange(val, node) {
      this.store.setChecked(node, val);
    },

    getNode(node) {
      return this.store.getNode(node);
    },

    getAllNodes() {
      return this.store.getAllNodes();
    },

    appendNode(parent, node) {
      this.store.appendNode(parent, node);
    },

    removeNode(node) {
      this.store.removeNode(node);
    },

    setNode(node, info) {
      this.store.setNode(node, info);
    },

    init() {
      this.store = new Store({
        data: this.data,
        lazy: this.lazy,
        nodeKey: this.nodeKey,
        expandAll: this.expandAll,
        multiSelect: this.multiSelect,
        load: this.load,
        loadMore: this.loadMore,
        hasMore: this.hasMore,
      });
      this.root = this.store.root;
    },

  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.qc-tree {
  height: 100%;
  overflow: hidden auto;
  .qc-tree-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    &>i {
      margin-right: 5px;
    }
  }
}
</style>
